/**
 * Fila clave/valor para los paneles de información (cliente, totales, etc.)
 * dentro de la vista de detalle de un documento de Facturación.
 *
 * Extraído de `pages/Billing.jsx` en el refactor preventivo de iteración 66.
 */
export default function InfoRow({ label, value, mono, strong }) {
  return (
    <div className="flex justify-between gap-2">
      <span className="font-mono text-[10px] uppercase tracking-widest text-[#525252]">{label}</span>
      <span className={`text-right ${mono ? "font-mono text-xs" : ""} ${strong ? "font-bold" : ""}`}>{value}</span>
    </div>
  );
}
